import React from 'react';
import { Box, Typography, Container, Paper, Divider } from '@mui/material';
import LayoutLandingHeader from '../components/LayoutLandingHeader';
import LayoutLandingFooter from '../components/LayoutLandingFooter';
import GSTLoader from '../components/GSTLoader'; // Import GSTLoader

const AboutUS = () => {
  return (
     <GSTLoader>
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        backgroundColor: '#f5f5f5',
      }}
    >
      <LayoutLandingHeader />
      <Box sx={{ flexGrow: 1, py: 6 }}>
        <Container maxWidth="md">
          <Paper elevation={3} sx={{ p: 5, borderRadius: 3 }}>
            <Typography
              variant="h4"
              align="center"
              gutterBottom
              sx={{ fontWeight: 'bold', color: '#003366' }}
            >
              About Us
            </Typography>

            <Divider sx={{ my: 3 }} />

            <Typography
              variant="body1"
              align="left"
              sx={{ mt: 2, color: '#333', lineHeight: 1.8, fontSize: '1.1rem' }}
            >
              <strong>EASUPTAX</strong> software simplifies GST invoicing for medium enterprises.
              Our mission is to make GST compliance hassle-free by leveraging modern technology.
              We understand that most compliance errors are caused by human mistakes — our goal is to reduce these errors and streamline the entire process.
              <br /><br />
              Our team of experienced consultants continuously monitors every change — big or small — in the GST Act, so you don’t have to.
              We translate this complex information into simple, actionable steps for your business.
            </Typography>

            <Typography
              variant="body1"
              align="left"
              sx={{ mt: 4, color: '#333', lineHeight: 1.8, fontSize: '1.1rem' }}
            >
              You simply issue invoices and enter your purchase bills as part of your normal business workflow.
              From there, our trained professionals handle:
              <ul style={{ marginTop: '10px', paddingLeft: '20px' }}>
                <li>Filing all your GST returns on time</li>
                <li>Matching your purchase and sales records</li>
                <li>Ensuring accurate compliance with the GST Act</li>
                <li>Updating your invoice formats as per new GST rules</li>
                <li>Informing you promptly about any notices or issues</li>
              </ul>
              <br />
              Our goal is simple — to let you focus on your business while we take care of the compliance complexities for you.
            </Typography>
          </Paper>
        </Container>
      </Box>
      <LayoutLandingFooter />
    </Box>
    </GSTLoader>
  );
};

export default AboutUS;
